import { axiosInstance } from "../../../../Services";
import { MMH_MASTERS_PATH, USE_MOCK } from "./config";
import { mockGetMasters } from "../mock/mockApi";

// Every dropdown the form needs, in one call: categories (with their ids),
// category types, styles, image categories, project types, costs, staircase
// types, basements and plan types. These live in database masters, so the
// panel reads them rather than hard-coding them.
export const GetMasters = async () => {
  if (USE_MOCK) {
    return mockGetMasters();
  }
  return axiosInstance.get(MMH_MASTERS_PATH);
};

export default GetMasters;
